/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// style imports
import './Register.scss';

// library imports
import { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import store from 'features/store';

import { bgTransparantBlack, registerHome } from 'shared/images/images';
import authService from 'shared/services/authService';
import { ACCESS_TOKEN, REFRESH_TOKEN } from 'shared/settings/token';
import { login, loginWithRes } from 'shared/settings/auth';
import { showAndHideJiraButton } from 'shared/jira-button';
import { authErrorMessage } from 'features/config/systemmessages';
import { getFormattedAppleLinkAndMessage } from 'shared/utils/utils';
import ScmSignin from '../signin/ScmSignin';

/**


@Author Karthik

@param

@return html code for register Page

**/

export class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleRegisterModal: false,
            innerWidth: window.innerWidth,
            welcomeMessageShow: false,
            displayname: null
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        setTimeout(() => {
            if(this.props.toggleRegisterModal) {
                store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
            }
        }, 3000);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
        this.setState({
            ...this.state,
            innerWidth: window.innerWidth
        });
    }

    signInOpen = (flag) => {
        store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: flag } });
    }

    handleClose = (event) => {
        if (this.state.innerWidth < 992) {
            if (!this.props.toggleSignInModal.open) {
                showAndHideJiraButton(false);
            }
        }
        store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
    }

    /** Called after sing complete in Google */
    responseGoogle = async (response) => {
        const data = {
            data: {
                token: response.tokenObj.id_token
            }
        };
        // const data = {
        //     data: {
        //         firstname: response.profileObj.givenName,
        //         lastname: response.profileObj.familyName,
        //         nickname: (response.profileObj.givenName + response.profileObj.familyName).toLocaleLowerCase(),
        //         email: response.profileObj.email,
        //         password: null
        //     }
        // };
        // this.registerAPICall(data);
        this.socialMediaSignInAndSignUp(data, 'google', response);
    };

    /** Called after sing complete in Facebook */
    responseFacebook = async (response) => {

        if (response.status !== 'unknown') {
            const data = {
                data: {
                    token: response.accessToken
                }
            };
            // const data = {
            //     data: {
            //         firstname: response.first_name,
            //         lastname: response.last_name,
            //         nickname: (response.first_name + response.last_name).toLocaleLowerCase(),
            //         email: response.email,
            //         password: null
            //     }
            // };
            // this.registerAPICall(data);

            this.socialMediaSignInAndSignUp(data, 'facebook', response);
        }
    };

    /** Called after sing complete in Apple */
    responseApple = async (response) => {
        this.setState({
            proxyEmail: false
        }, () => {
            this.appleSignHandle(response);
        });
    };

    appleSignHandle = (response) => {
        if (!this.state.proxyEmail) {
            const data = {
                data: {
                    user: {},
                    token: response['authorization']['id_token']
                }
            };

            if (response.hasOwnProperty('user')) {
                data['data']['user']['email'] = response['user']['email'];
                data['data']['user']['firstname'] = response['user']['name']['firstName'];
                data['data']['user']['lastname'] = response['user']['name']['lastName'];
            }

            // const data = {
            //     data: {
            //         firstname: response['user']['name']['firstName'],
            //         lastname: response['user']['name']['lastName'],
            //         nickname: (response['user']['name']['firstName'] + response['user']['name']['lastName']).toLocaleLowerCase(),
            //         email: response['user']['email'],
            //         password: null
            //     }
            // };
            // this.registerAPICall(data);
            this.socialMediaSignInAndSignUp(data, 'apple', response);

        }
    }

    socialMediaSignInAndSignUp = (data, media, extraData) => {
        switch (media) {
            case "google":
                this.googleAuth(data, media, extraData);
                break;
            case "facebook":
                this.facebookAuth(data, media, extraData);
                break;
            case "apple":
                this.appleAuth(data, media, extraData);
                break;
            default:
                console.error("Out of range");
                break;
        }

    }

    googleAuth = (data, media, extraData) => {
        const checkData = {
            data: {
                email: extraData.profileObj.email
            }
        };
        authService.googleAuthCheck(checkData).then(existCheck => {
            const existCheckData = existCheck.data.data;
            if (!existCheckData[0].exist) {
                authService.googleAuth(data).then(
                    response => {
                        const jsonData = response.data;
                        login({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }).then(res => {
                            this.handleClose(null);
                        }).catch(error => {
                            this.handleClose(null);
                        });
                    }
                ).catch(error => {
                    store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
                    store.dispatch({ type: "ERROR_MODAL", payload: { show: true, message: error.message ? error.message : "Something went wrong" } });
                });
            } else {
                store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
                store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: true, extraData: { media, data } } });
            }
        }).catch(error => {

        });
    }

    facebookAuth = (data, media, extraData) => {
        if (extraData.email) {
            const checkData = {
                data: {
                    email: extraData.email
                }
            };
            authService.facebookAuthCheck(checkData).then(existCheck => {
                const existCheckData = existCheck.data.data;
                if (!existCheckData[0].exist) {
                    authService.facebookAuth(data).then(
                        response => {
                            const jsonData = response.data;
                            login({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }, {props: this.props}).then(res => {
                                this.handleClose(null);
                            }).catch(error => {
                                this.handleClose(null);
                            });
                        }
                    ).catch(error => {
                        store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
                        store.dispatch({ type: "ERROR_MODAL", payload: { show: true, message: error.message ? error.message : "Something went wrong" } });
                    });
                } else {
                    store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
                    store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: true, extraData: { media, data } } });
                }
            }).catch(error => {

            });
        } else {
            store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
            store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: true, extraData: { media, data, error: true, errorMessage: authErrorMessage.facebookEmailEnable } } });

        }

    }

    appleAuth = (data, media, extraData) => {
        if (extraData['user'] && extraData['user']['email']) {
            const checkData = {
                data: {
                    email: extraData['user']['email']
                }
            };
            authService.appleAuthCheck(checkData).then(existCheck => {
                const existCheckData = existCheck.data.data;
                if (!existCheckData[0].exist) {
                    authService.appleAuth(data).then(
                        response => {
                            const jsonData = response.data;
                            login({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }).then(res => {
                                this.handleClose(null);
                            }).catch(error => {
                                this.handleClose(null);
                            });
                        }
                    ).catch(error => {
                        store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
                        const { message, link } = getFormattedAppleLinkAndMessage(error.message);
                        store.dispatch({ type: "ERROR_MODAL", payload: { show: true, message: message ? message : "Something went wrong", link: link ? link : null } });
                    });
                } else {
                    store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
                    store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: true, extraData: { media, data } } });
                }
            }).catch(error => {

            });
        } else {
            authService.appleAuth(data).then(
                response => {
                    const jsonData = response.data;
                    loginWithRes({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }).then((response) => {
                        this.handleClose(null);
                    }).catch(error => {
                        this.handleClose(null);
                    });
                }
            ).catch(error => {
                store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
                const { message, link } = getFormattedAppleLinkAndMessage(error.message);
                store.dispatch({ type: "ERROR_MODAL", payload: { show: true, message: message ? message : "Something went wrong", link: link ? link : null } });
            });
            // store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: false });
            // store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: true, extraData: { media, data, error: true, errorMessage: 'Choose Share My Email to get your email' } } });
        }
    }

    clearConsole = () => {
        
    }


    render() {
        return (
            <Modal id="register-modal-main"
                show={this.props.toggleRegisterModal} onHide={this.handleClose} animation={false}
                size="lg" className=" animate__animated animate__fadeInUp"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body style={{ background: `linear-gradient(rgba(255,255,255,70%), rgba(255,255,255,70%)), url(${bgTransparantBlack})` }}>
                    <div className="register-close-icon">
                        <div className="close-icon-1 clickable" onClick={this.handleClose}></div>
                    </div>
                    <div className="text-container">
                        <div style={{ textAlign: 'justify', width: '78%', marginLeft: '12%' }}>
                        Welcome to CTBids! Our process has changed where we require all
                        bidders to secure a payment method to bid. Your payment details
                        will be stored to your account and will be charged upon winning an
                        item. An initial $1.01 charge will be reflected on your card to verify
                        the payment method and will refund shortly after.
                        </div>
                    </div>
                    {
                        this.state.welcomeMessageShow ? <div className="welcome-message">
                            <div className="message-body  d-flex flex-column justify-content-center">
                                <h2>Welcome to CTBids</h2>
                                <div className="user-name h5">Hey {this.state.displayname}</div>
                                <div className="h5">
                                    Wow! Thanks for registering an account with CTBids, Before we get started, we'll need to verify your email
                                </div>
                                <div className="h5 mt-05">
                                    Please click verification link which we have sent to your registered email id.
                                </div>
                            </div>
                        </div> :
                            <div className="register-content" style={{ backgroundImage: `url(${registerHome})` }}>
                                <div className="align-container">
                                    <div className="sign-up text-center">
                                        {
                                            this.state.innerWidth > 767 ?
                                                <h4>
                                                    Already Registered? <div className="text-secondary mt-1 clickable" onClick={() => { this.signInOpen('Sign-In') }}>Sign In</div>
                                                </h4> :
                                                <h6>
                                                    Already Registered? <div className="text-secondary mt-1 clickable" onClick={() => { this.signInOpen('Sign-In') }}>Sign In</div>
                                                </h6>
                                        }
                                    </div>
                                    <div className="text-center sign-up">
                                        {
                                            this.state.innerWidth > 767 ?
                                                <h5>
                                                    New User? Sign Up With
                                                </h5> :
                                                <h6>
                                                    New User? Sign Up With
                                                </h6>
                                        }
                                    </div>
                                    <ScmSignin />
                                    <div className="hr-line"></div>
                                    <div className="sign-up-button already-signin">
                                        <Button variant="secondary" size={this.state.innerWidth > 768 ? "md" : "sm"} onClick={() => { this.signInOpen('Sign-Up') }}>Sign Up With Email</Button>
                                    </div>
                                    {/* <div className="text-center already-signin">
                                        Already Registered? <span onClick={() => { this.signInOpen('Sign-In') }}>Sign In</span>
                                    </div> */}
                                </div>
                            </div>
                    }
                    <div className="text-center mb-3 pb-2">
                        By using our website you are consenting to our use of
                        <span className="break-line"> cookies in accordance with <span className="external-link clickable">cookie policy</span></span>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}